import * as DownloadAnalyticsHelper from '../../../../containers/download-app/helpers/DownloadAnalyticsHelper.mjs';

const getAppDownloadLinkFooterBridge =
  DownloadAnalyticsHelper.getAppDownloadLinkFooter as (
    query_params: Record<string, string>,
    city: string | undefined,
    isDesktop: boolean,
    current_page_route: string,
  ) => string;

function getURLParams(searchStr: string): Record<string, string> {
  const urlParams: Record<string, string> = {};
  searchStr.split('&').forEach(param => {
    const parts = param.split('=');
    if (parts.length >= 2) {
      urlParams[parts[0]] = parts[1];
    }
  });
  return urlParams;
}

export function getFooterAppDownloadLink(
  asPath: string,
  city: string | undefined,
  isDesktop: boolean,
  currentPageRoute: string,
): string {
  return getAppDownloadLinkFooterBridge(
    getURLParams(asPath),
    city,
    isDesktop,
    currentPageRoute,
  );
}
